import { render, staticRenderFns } from "./GameRule.vue?vue&type=template&id=7ea48b6f&"
import script from "./GameRule.vue?vue&type=script&lang=js&"
export * from "./GameRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports